(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('FixationDialogController', FixationDialogController);

    FixationDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Fixation', 'Contract', 'Lot'];

    function FixationDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Fixation, Contract, Lot) {
        var vm = this;

        vm.fixation = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.contracts = Contract.query();
        vm.lots = Lot.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.fixation.id !== null) {
                Fixation.update(vm.fixation, onSaveSuccess, onSaveError);
            } else {
                Fixation.save(vm.fixation, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('ccsTrApp:fixationUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createdOn = false;
        vm.datePickerOpenStatus.modifiedOn = false;
        vm.datePickerOpenStatus.fixDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
